import { render, staticRenderFns } from "./AddressDetailCard.vue?vue&type=template&id=f3493438"
import script from "./AddressDetailCard.vue?vue&type=script&lang=js"
export * from "./AddressDetailCard.vue?vue&type=script&lang=js"
import style0 from "./AddressDetailCard.vue?vue&type=style&index=0&id=f3493438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports